// extracted by mini-css-extract-plugin
export default {"common":"Timeslot_common__ncDLl","h1":"Timeslot_h1__yBKV2","content":"Timeslot_content__mMzq6","spinner":"Timeslot_spinner__kDN2i","tableRow":"Timeslot_tableRow__fcLdi"};